import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Sidebar.css';
import { useUser } from '../../context/UserContext';

const Sidebar = () => {
  const { user } = useUser();
  const current_role = user?.role;
  const current_role_key = user?.role_key;
  const location = useLocation();
  const [activeMenu, setActiveMenu] = useState('');

  useEffect(() => {
    if (location.pathname.indexOf('user_dashboard') !== -1) {
      setActiveMenu('user_dashboard');
    } else if (location.pathname.startsWith('/companies')) {
      setActiveMenu('companies');
    } else if (location.pathname.startsWith('/users')) {
      setActiveMenu('users');
    } else if (location.pathname.startsWith('/accounts')) {
      setActiveMenu('accounts');
    } else if (location.pathname.startsWith('/demo_requests')) {
      setActiveMenu('demo_requests');
    } else if (location.pathname.startsWith('/user_stats')) {
      setActiveMenu('user_stats');
    }
  }, [location.pathname]);

  if (
    current_role_key === undefined ||
    current_role_key === 'CLIENT' ||
    current_role_key === 'CLIENT_EMPLOYEE' ||
    current_role_key === 'SALES_DEMO' ||
    current_role_key === 'ANALYST'
  ) {
    return null;
  }

  return (
    <aside className="sbx-sidebar">
      <ul className="sbx-nav">
        {current_role_key !== 'ANALYST' && (
          <li className={`sbx-item ${activeMenu === 'user_dashboard' ? 'is-active' : ''}`}>
            <Link className="sbx-link" to="/users/user_dashboard">
              <i className="fa fa-home sbx-icon" aria-hidden="true"></i>
              <span className="sbx-label">Home</span>
            </Link>
          </li>
        )}

        {current_role_key !== 'ACCOUNT_MANAGER' ? (
          <>
            {current_role_key !== 'ANALYST' && current_role_key !== 'CLIENT' && (
              <li className={`sbx-item ${activeMenu === 'companies' ? 'is-active' : ''}`}>
                <Link className="sbx-link" to="/companies">
                  <i className="fa fa-university sbx-icon" aria-hidden="true"></i>
                  <span className="sbx-label">Clients</span>
                </Link>
              </li>
            )}

            {current_role_key !== 'ANALYST' && current_role_key !== 'CLIENT' && (
              <li className={`sbx-item ${activeMenu === 'users' ? 'is-active' : ''}`}>
                <Link className="sbx-link" to="/users">
                  <i className="fa fa-users sbx-icon" aria-hidden="true"></i>
                  <span className="sbx-label">Users</span>
                </Link>
              </li>
            )}

            {current_role_key !== 'ANALYST' && (
              <li className={`sbx-item ${activeMenu === 'accounts' ? 'is-active' : ''}`}>
                <Link className="sbx-link" to="/accounts">
                  <i className="fa fa-cubes sbx-icon" aria-hidden="true"></i>
                  <span className="sbx-label">Accounts</span>
                </Link>
              </li>
            )}

            <li className={`sbx-item ${activeMenu === 'demo_requests' ? 'is-active' : ''}`}>
              <Link className="sbx-link" to="/demo_requests">
                <i className="fa fa-file-text  sbx-icon" aria-hidden="true"></i>
                <span className="sbx-label">Demo<br/>Requests</span>
              </Link>
            </li>
          </>
        ) : (
          <li className={`sbx-item ${activeMenu === 'user_stats' ? 'is-active' : ''}`}>
            <Link className="sbx-link" to="/user_stats/user_stats">
              <i className="fa fa-bar-chart sbx-icon" aria-hidden="true"></i>
              <span className="sbx-label">User&nbsp;Stats</span>
            </Link>
          </li>
        )}
      </ul>
    </aside>
  );
};

export default Sidebar;
